// Child analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeChildAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeChildAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis',
)({
  component: EnergyTreeNodeChildAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_breakdown' },
});
